var map = {
	"./ad.svg": "10e4",
	"./ae.svg": "3782",
	"./af.svg": "61f0",
	"./afar.svg": "f32e",
	"./ag.svg": "a93c",
	"./ai.svg": "b573",
	"./al.svg": "1b15",
	"./am.svg": "dce5",
	"./ao.svg": "56d6",
	"./aq.svg": "8c29",
	"./ar.svg": "888d",
	"./as.svg": "7c8d",
	"./at.svg": "e94c",
	"./au-aboriginal.svg": "68a5",
	"./au-act.svg": "8268",
	"./au-nsw.svg": "bed0",
	"./au-nt.svg": "3584",
	"./au-qld.svg": "e44e",
	"./au-sa.svg": "31ceb",
	"./au-tas.svg": "19d4",
	"./au-vic.svg": "f819",
	"./au-wa.svg": "f124",
	"./au.svg": "35bb",
	"./aw.svg": "2dda",
	"./ax.svg": "175c",
	"./az.svg": "edb8",
	"./ba.svg": "4b3a",
	"./bb.svg": "9f44",
	"./bd.svg": "0426",
	"./be.svg": "120b",
	"./bf.svg": "5b48",
	"./bg.svg": "ce35",
	"./bh.svg": "e041",
	"./bi.svg": "94ba",
	"./bj.svg": "a986",
	"./bl.svg": "a145",
	"./bm.svg": "4e21",
	"./bn.svg": "278a",
	"./bo.svg": "a6c2",
	"./bq-bo.svg": "7990",
	"./bq-sa.svg": "2aca",
	"./bq-se.svg": "65d1",
	"./br.svg": "26c9",
	"./bs.svg": "6877",
	"./bt.svg": "e864",
	"./bw.svg": "9186",
	"./by.svg": "12c2",
	"./bz.svg": "6fbd",
	"./ca-bc.svg": "61cd",
	"./ca.svg": "bd77",
	"./cc.svg": "e246",
	"./cd.svg": "126b",
	"./cf.svg": "dd35",
	"./cg.svg": "f962",
	"./ch-gr.svg": "8f88",
	"./ch.svg": "e722",
	"./ci.svg": "f797",
	"./ck.svg": "b1f1",
	"./cl.svg": "d11e",
	"./cm.svg": "d557",
	"./cn-xj.svg": "3fe4",
	"./cn.svg": "f79a",
	"./co.svg": "1bf9",
	"./cq.svg": "3d77",
	"./cr.svg": "256e",
	"./cu.svg": "816b",
	"./cv.svg": "0a85",
	"./cw.svg": "394c",
	"./cx.svg": "2ba7",
	"./cy.svg": "eb80",
	"./cz.svg": "9ce1",
	"./de.svg": "62d8",
	"./dj.svg": "f3ad",
	"./dk.svg": "5647",
	"./dm.svg": "a828",
	"./do.svg": "e43e",
	"./dz.svg": "e1c3",
	"./earth.svg": "bb45",
	"./east_african_federation.svg": "c5e6",
	"./easter_island.svg": "7351",
	"./ec-w.svg": "4065",
	"./ec.svg": "d882",
	"./ee.svg": "bc05",
	"./eg.svg": "4d27",
	"./eh.svg": "627e",
	"./er.svg": "ef98",
	"./es-ar.svg": "a798",
	"./es-ce.svg": "c5ed",
	"./es-cn.svg": "3ff7",
	"./es-ct.svg": "e728",
	"./es-ga.svg": "4062",
	"./es-ib.svg": "c539",
	"./es-ml.svg": "ff36",
	"./es-pv.svg": "61f5",
	"./es-variant.svg": "dcb2",
	"./es.svg": "c214",
	"./et-or.svg": "08bb",
	"./et-ti.svg": "041d",
	"./et.svg": "bff5",
	"./european_union.svg": "abe3",
	"./ewe.svg": "6b1c",
	"./fi.svg": "ddd86",
	"./fictional/klingon.svg": "d23c",
	"./fj.svg": "3b73",
	"./fk.svg": "3f16",
	"./fm.svg": "afeb",
	"./fo.svg": "21da",
	"./fr-20r.svg": "248f",
	"./fr-bre.svg": "5f5d",
	"./fr-cp.svg": "e1df",
	"./fr.svg": "30ce",
	"./ga.svg": "3f7e",
	"./gb-con.svg": "6a9c",
	"./gb-eng.svg": "8626",
	"./gb-nir.svg": "8f3f",
	"./gb-ork.svg": "646e",
	"./gb-sct.svg": "cbce",
	"./gb-wls.svg": "b4fb",
	"./gb.svg": "5747",
	"./gd.svg": "2953",
	"./ge-ab.svg": "5a0f",
	"./ge.svg": "d4bb",
	"./gf.svg": "c057",
	"./gg.svg": "783e",
	"./gh.svg": "c21c",
	"./gi.svg": "aea0",
	"./gl.svg": "04bb",
	"./gm.svg": "4300",
	"./gn.svg": "2186",
	"./gp.svg": "80cc",
	"./gq.svg": "0621",
	"./gr.svg": "ebc0",
	"./gs.svg": "45c6",
	"./gt.svg": "1a30",
	"./gu.svg": "1aab",
	"./guarani.svg": "5ef2",
	"./gw.svg": "34ed",
	"./gy.svg": "700e",
	"./hausa.svg": "492e",
	"./hk.svg": "70d6",
	"./hmong.svg": "6635",
	"./hn.svg": "0170",
	"./hr.svg": "90cd",
	"./ht.svg": "998b",
	"./hu.svg": "2cff",
	"./id-jb.svg": "1f8f",
	"./id-jt.svg": "a1d9",
	"./id.svg": "2b2b",
	"./ie.svg": "e45e",
	"./il.svg": "a7eb",
	"./im.svg": "9f4c",
	"./in-as.svg": "1794",
	"./in-gj.svg": "dc26",
	"./in-ka.svg": "2ffe",
	"./in-or.svg": "05c3",
	"./in-tg.svg": "e1b6",
	"./in-tn.svg": "28db",
	"./in.svg": "bb04",
	"./io.svg": "d044",
	"./iq.svg": "91e4",
	"./ir.svg": "a48d",
	"./is.svg": "ce6e",
	"./it-23.svg": "b364",
	"./it-82.svg": "0d1d",
	"./it-88.svg": "71ab",
	"./it.svg": "1187",
	"./je.svg": "3ef7",
	"./jm.svg": "f4fc",
	"./jo.svg": "c692",
	"./jp.svg": "acb1",
	"./kanuri.svg": "7461",
	"./ke.svg": "b7d5",
	"./kg.svg": "26d0",
	"./kh.svg": "2591",
	"./ki.svg": "9dbc",
	"./kikuyu.svg": "8020",
	"./km.svg": "d6cb",
	"./kn.svg": "bb19",
	"./kongo.svg": "5e15",
	"./kp.svg": "938d",
	"./kr.svg": "b72d",
	"./kurdistan.svg": "9956",
	"./kw.svg": "24d9",
	"./ky.svg": "9714",
	"./kz.svg": "d1df",
	"./la.svg": "ce67",
	"./language/ar.svg": "9da0",
	"./language/en-au.svg": "e5cc",
	"./language/en-ca.svg": "2bae",
	"./language/en-in.svg": "4b65",
	"./language/en-ng.svg": "8532",
	"./language/en-nz.svg": "c986",
	"./language/en-us.svg": "db4c",
	"./language/en-za.svg": "5c16",
	"./language/eo.svg": "4f29",
	"./language/ia.svg": "b12c",
	"./language/ie.svg": "5942",
	"./language/interslavic.svg": "abfd",
	"./language/io.svg": "f3d5",
	"./language/la.svg": "dba7",
	"./language/mr.svg": "ab88",
	"./language/non.svg": "daa9",
	"./language/vo.svg": "0f148",
	"./language/yi.svg": "76fa",
	"./lb.svg": "ad1d",
	"./lc.svg": "d7f0",
	"./li.svg": "8c84",
	"./lk.svg": "7398",
	"./lr.svg": "f655",
	"./ls.svg": "f004",
	"./lt.svg": "62ae",
	"./lu.svg": "fd7f",
	"./lv.svg": "eb67",
	"./ly.svg": "2a93",
	"./ma.svg": "9750",
	"./malayali.svg": "f44c",
	"./manipur.svg": "f756",
	"./maori.svg": "49ff",
	"./mc.svg": "6949",
	"./md.svg": "7faf",
	"./me.svg": "dfca",
	"./mf.svg": "9ca0",
	"./mg.svg": "7cb1",
	"./mh.svg": "96f1",
	"./mizoram.svg": "0087",
	"./mk.svg": "1ea5",
	"./ml.svg": "4b40",
	"./mm.svg": "3f83",
	"./mn.svg": "aad4",
	"./mo.svg": "8d42",
	"./mp.svg": "d1a0",
	"./mq.svg": "cd4c",
	"./mr.svg": "97b3",
	"./ms.svg": "e8f0",
	"./mt.svg": "c9b2",
	"./mu.svg": "b7a0",
	"./mv.svg": "e3de",
	"./mw.svg": "149d",
	"./mx.svg": "4bc5",
	"./my.svg": "a60b",
	"./mz.svg": "aa6a",
	"./na.svg": "3d4c",
	"./nato.svg": "74cb",
	"./nc.svg": "193b",
	"./ne.svg": "3767",
	"./nf.svg": "9321",
	"./ng.svg": "59bc",
	"./ni.svg": "4de6",
	"./nl-fr.svg": "79e7",
	"./nl.svg": "e661",
	"./no.svg": "34b6",
	"./northern_cyprus.svg": "a001",
	"./np.svg": "563a",
	"./nr.svg": "06f5",
	"./nu.svg": "558d",
	"./nz.svg": "b813",
	"./occitania.svg": "64a3",
	"./olympics.svg": "fa1a",
	"./om.svg": "1a56",
	"./otomi.svg": "52f4",
	"./pa.svg": "049b",
	"./pe.svg": "50e7",
	"./pf.svg": "da35",
	"./pg.svg": "10b3",
	"./ph.svg": "1f99",
	"./pk-jk.svg": "a359",
	"./pk-sd.svg": "aa8d",
	"./pk.svg": "9abd",
	"./pl.svg": "f63c",
	"./pm.svg": "325e",
	"./pn.svg": "6cfe",
	"./pr.svg": "40fc",
	"./ps.svg": "9aa5",
	"./pt-20.svg": "c6cb",
	"./pt-30.svg": "7f71",
	"./pt.svg": "9c77",
	"./pw.svg": "50631",
	"./py.svg": "5737",
	"./qa.svg": "32a0",
	"./quechua.svg": "166a8",
	"./re.svg": "ecad",
	"./ro.svg": "8fe0",
	"./rs.svg": "6aed",
	"./ru-ba.svg": "cb92",
	"./ru-ce.svg": "e337",
	"./ru-cu.svg": "cd16",
	"./ru-da.svg": "971d",
	"./ru-ko.svg": "62fd",
	"./ru-ta.svg": "fe67",
	"./ru-ud.svg": "bc56",
	"./ru.svg": "1c8d",
	"./rw.svg": "60c2",
	"./sa.svg": "2e3e",
	"./sami.svg": "250f",
	"./sb.svg": "fee6",
	"./sc.svg": "e1ff",
	"./sd.svg": "8650",
	"./se.svg": "081c",
	"./sg.svg": "8b1b",
	"./sh-ac.svg": "ffb6",
	"./sh-hl.svg": "54c9",
	"./sh-ta.svg": "c1fa",
	"./si.svg": "d5e2",
	"./sk.svg": "8f15",
	"./sl.svg": "13dd",
	"./sm.svg": "1dbd",
	"./sn.svg": "d6f3",
	"./so.svg": "f021",
	"./somaliland.svg": "38e4",
	"./south_ossetia.svg": "6f7c",
	"./soviet_union.svg": "284e",
	"./sr.svg": "2871",
	"./ss.svg": "f15b",
	"./st.svg": "33f1",
	"./sv.svg": "1264",
	"./sx.svg": "9685",
	"./sy.svg": "1f6e",
	"./sz.svg": "c616",
	"./tc.svg": "34d9",
	"./td.svg": "db28",
	"./tf.svg": "2795",
	"./tg.svg": "d00b",
	"./th.svg": "4a28",
	"./tibet.svg": "04db",
	"./tj.svg": "34e6",
	"./tk.svg": "2c3d",
	"./tl.svg": "30a7",
	"./tm.svg": "c4e9",
	"./tn.svg": "1e1d",
	"./to.svg": "6b41",
	"./torres_strait_islands.svg": "b316",
	"./tr.svg": "e2d7",
	"./transnistria.svg": "8d0a",
	"./tt.svg": "304a",
	"./tv.svg": "8fa7",
	"./tw.svg": "06fc",
	"./tz.svg": "bb0d",
	"./ua.svg": "d8cb",
	"./ug.svg": "1b8c",
	"./united_nations.svg": "0f7d",
	"./us-ak.svg": "4d70",
	"./us-al.svg": "652f",
	"./us-ar.svg": "b693",
	"./us-az.svg": "5ffb",
	"./us-ca.svg": "67ab",
	"./us-co.svg": "9c0c",
	"./us-dc.svg": "f8c5",
	"./us-fl.svg": "9864",
	"./us-ga.svg": "eff7",
	"./us-hi.svg": "dbe3",
	"./us-in.svg": "1c14",
	"./us-mo.svg": "13eb",
	"./us-ms.svg": "c3d5",
	"./us-nc.svg": "57de",
	"./us-nm.svg": "906f",
	"./us-ri.svg": "fea2",
	"./us-tn.svg": "cc53",
	"./us-tx.svg": "15482",
	"./us.svg": "cc63",
	"./uy.svg": "27cd",
	"./uz.svg": "da4b",
	"./va.svg": "dd98",
	"./vc.svg": "e9fe",
	"./ve.svg": "c92c",
	"./vg.svg": "d714",
	"./vi.svg": "a5a2",
	"./vn.svg": "bd80",
	"./vu.svg": "c0e4",
	"./wf.svg": "13fe",
	"./wiphala.svg": "001b",
	"./ws.svg": "147a",
	"./xk.svg": "e4d35",
	"./xx.svg": "836d",
	"./ye.svg": "fd10",
	"./yorubaland.svg": "6147",
	"./yt.svg": "eb80e",
	"./za.svg": "ac64",
	"./zm.svg": "ea2c",
	"./zw.svg": "76bb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "713ab";